export default __webpack_public_path__ + "static/media/lockrScan-success-check.c7ac7aec.svg";